import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum PanelOrdersResolverErrorStatesEnum {
    NoPermissions = ErrorStateScheduleEnum.FundOrdersReportResolverStatesStartIndex,
    GetProductsFailed,
    SearchClientsAccounts,
    GetOrdersFailed
}
